import enviro from 'enviro';
const isProd = enviro.isProd();
const PRODUCT_HUBSPOT_FREE_QA = 56;
const PRODUCT_HUBSPOT_FREE_PROD = 56;
export const PRODUCT_HUBSPOT_FREE = isProd ? PRODUCT_HUBSPOT_FREE_PROD : PRODUCT_HUBSPOT_FREE_QA;